import React from "react";
import { Image } from "./image";

export const ProfServ = (props) => {
  return (
    <div id="profServ" className="text-center">
      <div className="container">
        <div className="col-md-8 col-md-offset-2 section-title">
          <h2>Professional Service</h2>
          <h3>Selected Projects</h3>
          <div className="text-justify-xs">
            <br></br>
            <h3>Programming</h3>{" "}
            <div class="row justify-xs-content-center">
              <div class="col-auto">
                <table class="table programming-table">
                  <tbody>
                    <tr>
                      <th scope="row">
                        <div className="thumbnail">
                          <Image
                            largeImage="img/ps/soundscaper.png"
                            smallImage="img/ps/soundscaper_m.png"
                          />
                        </div>
                      </th>
                      <td>
                        {" "}
                        <div className="caption">
                          <h4>
                            SOUNDSCAPER - Software for the creation of the
                            touristic audio guided tours with audio augmented
                            reality.
                          </h4>
                          <p>Soundscaper d.o.o. Split 2024.</p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <div className="thumbnail">
                          <Image
                            largeImage="img/ps/TGM3.jpg"
                            smallImage="img/ps/TGM3_m.jpg"
                          />
                        </div>
                      </th>
                      <td>
                        {" "}
                        <div className="caption">
                          <h4>
                            TGM - TIN & Grid Maker - Software for the creation
                            of the DTM (Digital terrain model)
                          </h4>
                          <p>OBALA d.o.o. Split 2011.</p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <div className="thumbnail">
                          <Image
                            largeImage="img/ps/porat1.gif"
                            smallImage="img/ps/porat1_m.jpg"
                          />
                        </div>
                      </th>
                      <td>
                        {" "}
                        <div className="caption">
                          <h4>
                            PORAT - FEM simulaiton of the sea waves propagation
                            in bays and harbours, calculating the refraction and
                            the diffration of waves.
                          </h4>
                          <p>Obala d.o.o. Split 2002.</p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <br></br>
            <h3>Studies</h3>{" "}
            <div class="row justify-xs-content-center">
              <div class="col-auto">
                <table class="table">
                  <tbody>
                    <tr>
                      <th scope="row">
                        <div className="thumbnail">
                          <img src="img/ps/mim.png" height="50px" alt="" />
                        </div>
                      </th>
                      <td>
                        {" "}
                        <div className="caption">
                          <h4>
                            Circulation Study of Thematic Walks of Ivan
                            Meštrović
                          </h4>
                          <p>Muzeji Ivana Meštrovića 2018.</p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <div className="thumbnail">
                          <img src="img/ps/split.png" height="50px" alt="" />
                        </div>
                      </th>
                      <td>
                        {" "}
                        <div className="caption">
                          <h4>
                            Analysis of Current Geographic Information Systems
                            in City of Split Administration
                          </h4>
                          <p>City of Split 2012</p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <br></br>
            <h3>Maps</h3>{" "}
            <div class="row justify-xs-content-center">
              <div class="col-auto">
                <table class="table">
                  <tbody>
                    <tr>
                      <th scope="row">
                        <div className="thumbnail">
                          <Image
                            largeImage="img/ps/biokovo.jpg"
                            smallImage="img/ps/biokovo_m.jpg"
                          />
                        </div>
                      </th>
                      <td>
                        {" "}
                        <div className="caption">
                          <h4>Map of Biokovo Nature Park</h4>
                          <p>Biokovo Nature Park Public Institution 2007.</p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <div className="thumbnail">
                          <Image
                            largeImage="img/ps/zadar.jpg"
                            smallImage="img/ps/zadar_m.jpg"
                          />
                        </div>
                      </th>
                      <td>
                        {" "}
                        <div className="caption">
                          <h4>Map of Zadar Archipelago</h4>
                          <p>
                            Hydrographic Institute of the Republic of Croatia
                            2007.
                          </p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <div className="thumbnail">
                          <Image
                            largeImage="img/ps/vis21.jpg"
                            smallImage="img/ps/vis_m.jpg"
                          />
                        </div>
                      </th>
                      <td>
                        {" "}
                        <div className="caption">
                          <h4>Map of the Island of Vis</h4>
                          <p>BIS media d.o.o. Zagreb 2005.</p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <br></br>
            <h3>Geographic Information Systems</h3>{" "}
            <div class="row justify-xs-content-center">
              <div class="col-auto">
                <table class="table">
                  <tbody>
                    <tr>
                      <th scope="row">
                        <div className="thumbnail">
                          <Image
                            largeImage="img/ps/more.jpg"
                            smallImage="img/ps/zupa_m.jpg"
                          />
                        </div>
                      </th>
                      <td>
                        {" "}
                        <div className="caption">
                          <h4>GIS and WebGIS of Split-Dalmatia County</h4>
                          <p>Split-Dalmatia County 2005.</p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <div className="thumbnail">
                          <img src="img/ps/mzopu_m.jpg" height="50px" alt="" />
                        </div>
                      </th>
                      <td>
                        {" "}
                        <div className="caption">
                          <h4>Registry of Spatial Documentation of Croatia</h4>
                          <p>
                            Minstry of Environmental Protections, Physical
                            Planning and Constructions, Zagreb 2003.
                          </p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <br></br>
            <div class="text-justify-xs">
              <h3>
                Topographic Maps Georeferencing for Cities and Municipalities of
              </h3>{" "}
              <div class="row">
                <div class="col-auto">
                  <p>
                    Trilj (2008), Muć (2007), Imotski (2006), Trogir (2006),
                    Lokvičić (2005), Metković (2006), Podbablje (2006), Proložac
                    (2005), Zmijavci (2005), Šolta (2004)
                  </p>
                </div>
              </div>
              <br></br>
              <h3>
                Cadastral Maps Georeferencing for Cities and Municipalities of
              </h3>{" "}
              <div class="row">
                <div class="col-auto">
                  <p>
                    Trilj (2008), Muć (2007), Imotski (2006), Murter (2006),
                    Podbablje (2006), Trogir (2006), Tučepi (2006), Lokvičić
                    (2005), Proložac (2005), Zmijavci (2005), Šolta (2004)
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
